import { PageLoader } from 'components/Page/Page.Loader'
import ErrorBoundaryContainer from 'containers/ErrorBoundary'
import PropTypes from 'prop-types'
import React from 'react'

function Noop () {
  return <></>
}

class ComponentLoader extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      Component: null
    }
    this._isMounted = null
  }

  componentDidMount () {
    this._isMounted = true
    if (this.props.loadComponent) {
      this.loadComponent()
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  componentDidUpdate (prevProps) {
    if (BROWSER) {
      if (
        this.props.loadComponent &&
        prevProps.loadComponent !==
        this.props.loadComponent
      ) {
        this.loadComponent()
      }
    }
  }

  safeSetState (updates) {
    if (!this._isMounted) {
      return
    }
    this.setState(updates)
  }

  async loadComponent () {
    const {
      loadComponent,
      componentExportName
    } = this.props
    let componentWrapper
    if (typeof loadComponent === 'function') {
      componentWrapper = await this.props.loadComponent()
    } else {
      componentWrapper = await this.props.loadComponent
    }

    let Component
    if (componentWrapper?.[componentExportName]) {
      Component = componentWrapper[componentExportName]
    } else if (componentWrapper?.default) {
      Component = componentWrapper.default
    } else {
      Component = componentWrapper
    }

    this.safeSetState({
      Component
    })
  }

  render () {
    let element
    let Component = this.state.Component
    if (!Component && this.props.children) {
      element = this.props.children
    } else {
      Component = Component || (this.props.shouldNotShowLoader ? Noop : PageLoader)
      element = <Component {...this.props} wasLazyLoaded />
    }

    return (
      <ErrorBoundaryContainer>
        {element}
      </ErrorBoundaryContainer>
    )
  }
}

ComponentLoader.propTypes = {
  loadComponent: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func
  ]),
  shouldNotShowLoader: PropTypes.bool,
  componentExportName: PropTypes.string
}

export default ComponentLoader
